import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PaymentRecordAdvanceWidget from '../../../widgets/paymentRecordAdvanceWidgets/PaymentRecordAdvanceWidget'
import '../styles.less'
import { getPaymentRecordAdvance } from '../../../redux/actions/paymentRecordAdvance'
import { sessionGetItemStr, sessionGetItemObj } from '../../../utils/sessionHelpers'

//ยืมเงินทดลองจ่าย
export default function PaymentRecordAdvance() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const projectCode = sessionGetItemStr('projectCode')
  const borrowId = sessionGetItemStr('borrowId')
  const { periodNumber } = sessionGetItemObj('periodInfo')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getPaymentRecordAdvance(projectCode, periodNumber, borrowId)
      // console.log('*** ', _schema)
      setSchema(_schema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isIncomeExpense>
      <ContentHeader header={schema.header} subHeader={''} isNotCallApi isShowGoButton />

      <PaymentRecordAdvanceWidget schema={schema} />

      <br />
    </SidebarProposal>
  )
}
